import { render } from "./rp.vue?vue&type=template&id=12958770&scoped=true"
import script from "./rp.vue?vue&type=script&lang=js"
export * from "./rp.vue?vue&type=script&lang=js"

import "./rp.vue?vue&type=style&index=0&id=12958770&scoped=true&lang=css"

import exportComponent from "E:\\lb\\vue30\\tuiguang_meng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12958770"]])

export default __exports__